module.exports = __webpack_public_path__ + "img/floating-whatsapp.6830b5fa.png";